module.exports = __webpack_public_path__ + "assets/img/service-QRcord-zx.6b399526.jpg";